import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  promotionList: [],
  promotionDetail: [],
  loading: false,
  error: undefined,
};

const promotionSlice = createSlice({
  name: "promotion",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchPromotionList(state, action) {
      state.promotionList = action.payload;
      state.loading = false;
    },
    fetchPromotionDetail(state, action) {
      state.promotionDetail = action.payload;
      state.loading = false;
    },
    fetchPromotionClearDetail(state, action) {
      state.promotionDetail = [];
      state.loading = false;
    },
  },
});

export const promotionActions = promotionSlice.actions;

export default promotionSlice.reducer;
